import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check } from "lucide-react"

import { cn } from "@/lib/utils"

const Checkbox = React.forwardRef(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer shrink-0 rounded-[4px] border border-white/20 shadow focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-gold-leaf data-[state=checked]:border-gold-leaf data-[state=checked]:text-obsidian w-[14px] h-[14px]",
      className
    )}
    style={{ width: 14, height: 14, minWidth: 14, maxWidth: 14, minHeight: 14, maxHeight: 14, aspectRatio: '1/1', boxSizing: 'border-box' }}
    {...props}>
    <CheckboxPrimitive.Indicator className={cn("flex items-center justify-center text-current w-full h-full")}>
      <Check className="w-[10px] h-[10px]" strokeWidth={3} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
